import { render, staticRenderFns } from "./edito-faq.vue?vue&type=template&id=27a4bd04"
import script from "./edito-faq.vue?vue&type=script&lang=js"
export * from "./edito-faq.vue?vue&type=script&lang=js"
import style0 from "./edito-faq.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsUiText: require('/home/node/app/components/elements/ui-text/ui-text.vue').default,PatternsAccordionList: require('/home/node/app/components/patterns/accordion-list/accordion-list.vue').default,ElementsUiWrapper: require('/home/node/app/components/elements/ui-wrapper/ui-wrapper.vue').default})
